module.exports = __webpack_public_path__ + "img/certs.4250d2a2.png";